import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const stylesV2 = StyleSheet.create({
  button: {
    flexGrow: 0,
    width: '100%',
    height: 'auto',
    paddingVertical: 13,
    paddingHorizontal: 8.5,
    borderRadius: 8,
  },
  buttonV3: {
    flexGrow: 0,
    width: '100%',
    height: 'auto',
    paddingVertical: 13,
    paddingHorizontal: 8.5,
    borderRadius: 8,
  },
  buttonHover: {
    backgroundColor: neutrals.coldGrays.ice,
  },
  buttonSelected: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonFocus: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonInner: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'start',
    minHeight: 40,
  },
  toolDetailsContainer: {
    flex: 1,
    height: '100%',
    width: '100%',
    paddingLeft: 12,
  },
  toolDetails: {
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    gap: 8,
  },
  toolDetailsText: {
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 15.6,
    letterSpacing: 0.32,
    whiteSpace: 'nowrap',
  },
  toolDetailsTitle: {
    fontWeight: 700,
    fontSize: 14,
    // lineHeight: 21,
    letterSpacing: 0,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'left',
  },
  toolDetailsSubtitle: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 10,
    letterSpacing: 0,
    textAlign: 'left',
  },
  iconContainer: {},
  icon: {
    color: neutrals.neutralGrays.ash,
    width: 20,
    height: 20,
  },
});

export const stylesMobile = StyleSheet.create({
  button: {
    padding: 6,
    borderRadius: 8,
  },
  buttonLookup: {
    minWidth: 50,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 24,
    backgroundColor: neutrals.coldGrays.ice,
  },
  buttonHover: {
    backgroundColor: neutrals.coldGrays.ice,
  },
  buttonSelected: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonFocus: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
  buttonDisabled: {
    opacity: 0.6,
  },
  buttonInner: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  },
  toolDetails: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  toolDetailsText: {
    textAlign: 'center',
    color: neutrals.neutralGrays.graphite,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 16,
  },
  toolDetailsSubtitle: {
    color: brand.main.water,
    fontWeight: 700,
    fontSize: 10,
    letterSpacing: 0,
    textAlign: 'left',
  },
  iconContainer: {},
  icon: {
    color: neutrals.neutralGrays.ash,
    width: 20,
    height: 20,
  },
  toolTextSelected: {
    textAlign: 'center',
    color: brand.main.water,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 16,
  },
});
